import { render, staticRenderFns } from "./AdminAccount.vue?vue&type=template&id=2779e0d4&"
import script from "./AdminAccount.vue?vue&type=script&lang=ts&"
export * from "./AdminAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports